import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayeredImage } from 'Components/Images/LayeredImage/LayeredImage';
import PropTypes from 'prop-types';
import './image-navigation-item.scss';

export default function ImageNavigationItem({ active, title, image, className, id }) {
  const getClassName = () => {
    if (active) {
      return `${className} active`;
    }
    return className;
  };

  return (
    <div id={id || null} className={getClassName()}>
      <div className="image-navigation-title">{title}</div>
      <div className="image-navigation-image">
        <LayeredImage image={image} />
      </div>
    </div>
  );
}

ImageNavigationItem.defaultProps = {
  className: 'image-navigation-item',
  id: null,
};

ImageNavigationItem.propTypes = {
  active: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};
